import { useEffect, useState } from 'react';
import { loadHomeCatalog, normalizeProducts, readCatalogCache } from './HomeCatalog';

let state = { products: readCatalogCache(), loading: true, error: false };
let pending, refreshedAt = 0;
const listeners = new Set();
const publish = update => { state = { ...state, ...update }; listeners.forEach(listener => listener(state)); };
function refresh(force = false) {
    if (pending) return pending;
    if (!force && Date.now() - refreshedAt < 30000) return Promise.resolve();
    publish({ loading: true });
    pending = loadHomeCatalog(products => {
        // Keep previously loaded cards visible while the remaining pages arrive.
        if (products.length) publish({ products: normalizeProducts([...state.products, ...products]) });
    }).then(products => {
        if (!products.length && state.products.length) { publish({ error: true }); return; }
        refreshedAt = Date.now(); publish({ products, error: false });
    })
        .catch(() => publish({ error: true }))
        .finally(() => { pending = null; publish({ loading: false }); });
    return pending;
}

export default function useHomeCatalog() {
    const [catalog, setCatalog] = useState(state);
    useEffect(() => {
        listeners.add(setCatalog);
        setCatalog(state);
        refresh();
        const resume = () => { if (!document.hidden) refresh(); };
        window.addEventListener('online', resume);
        window.addEventListener('focus', resume);
        document.addEventListener('visibilitychange', resume);
        const timer = window.setInterval(resume, 60000);
        return () => {
            listeners.delete(setCatalog);
            window.removeEventListener('online', resume);
            window.removeEventListener('focus', resume);
            document.removeEventListener('visibilitychange', resume);
            window.clearInterval(timer);
        };
    }, []);
    return { ...catalog, retry: () => refresh(true) };
}
